export default "__VITE_ASSET__TiIUE_C___"